import * as tslib_1 from "tslib";
import { Injectable, Pipe } from '@angular/core';
import { ConfigService } from './config.service';
var ConfigPipe = (function () {
    function ConfigPipe(config) {
        this.config = config;
    }
    ConfigPipe.prototype.transform = function (value) {
        return this.config.getSettings(value);
    };
    return ConfigPipe;
}());
ConfigPipe = tslib_1.__decorate([
    Injectable(),
    Pipe({
        name: 'config'
    }),
    tslib_1.__metadata("design:paramtypes", [ConfigService])
], ConfigPipe);
export { ConfigPipe };



//////////////////
// WEBPACK FOOTER
// /Users/Nathan/Desktop/Computing Sciences/dissertation/pairgo/pairgo-ng/~/@ngx-config/core/src/config.pipe.js
// module id = ../../../../@ngx-config/core/src/config.pipe.js
// module chunks = 4